/* eslint-disable no-alert, no-console */
/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { patchV2UsersPasswordResetsIdClient } from "./patchV2UsersPasswordResetsIdClient.ts";
import { postV1UsersPasswordResetsClient } from "./postV1UsersPasswordResetsClient.ts";
import { postV1UsersSessionsClient } from "./postV1UsersSessionsClient.ts";
import { postV2UsersPasswordResetsClient } from "./postV2UsersPasswordResetsClient.ts";

export function authenticationService() {
  return { postV1UsersSessionsClient, postV1UsersPasswordResetsClient, postV2UsersPasswordResetsClient, patchV2UsersPasswordResetsIdClient }
}